module.exports = __webpack_public_path__ + "static/media/nacelle.112ae1f6.png";